import { Component } from '@grafikr/components';
import Drawer from "../utils/components/drawer";
import CartDrawer from "../utils/cart-drawer";

export default Component((node, { app }) => {
  const drawer = new Drawer(node);
  new CartDrawer(node, app);

  const closeTriggers = node.querySelectorAll<HTMLButtonElement>('[data-close]');
  const triggers = document.querySelectorAll('[data-load="cart-drawer"]');

  closeTriggers.forEach((close) => {
    close.addEventListener('click', drawer.close);
  });

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', drawer.open);
  });

  const onSelect = ({ detail }: { detail: { sectionId: string; } }) => {
    if (detail.sectionId == "cart-drawer") {
      drawer.open();
    }
  }

  if (window.location.search.includes("cart=1")) {
    drawer.open();
    window.history.replaceState(null, "", `${window.location.origin}${window.location.pathname}`);
  }

  document.addEventListener('cart-drawer:open', drawer.open);
  document.addEventListener('shopify:section:select', onSelect);
  document.addEventListener('shopify:block:select', onSelect);
});
